// extracted by mini-css-extract-plugin
export default {"titleTextContainer":"text_titleTextContainer__EcCy3"};